const baseUrl = process.env.REACT_APP_REST_API || 'http://localhost:4000/api';
//TODO remove unnecessary extra variables and merge them into 1
export const clubUrl = {
  CREATE_CLUB: `${baseUrl}/club`,
  UPDATE_CLUB: `${baseUrl}/club`,
  GET_CLUBS: `${baseUrl}/club`,
  GET_CLUB: `${baseUrl}/club/`,
};

export const evenTypeUrl = {
  CREATE_EVENT_TYPE: `${baseUrl}/event_type`,
  UPDATE_EVENT_TYPE: `${baseUrl}/event_type`,
  GET_EVENTS_TYPES: `${baseUrl}/event_type`,
  GET_EVENT_TYPE: `${baseUrl}/event_type/`,
};

export const userUrl = {
  CREATE_USER: `${baseUrl}/auth`,
  UPDATE_USER: `${baseUrl}/auth`,
  GET_USERS: `${baseUrl}/auth`,
  GET_USER: `${baseUrl}/auth`,
  DELETE_USER: `${baseUrl}/auth/delete`
};

export const campUrl = {
  BASE_URL: `${baseUrl}/camp`,
};

export const eventUrl = {
  BASE_URL: `${baseUrl}/event`,
  CREATE_EVENT: `${baseUrl}/event`,
  UPDATE_EVENT: `${baseUrl}/event`,
  GET_EVENTS: `${baseUrl}/event`,
  GET_EVENT_TYPE: `${baseUrl}/event`,
  GET_INSPECTION_EVENTS: `${baseUrl}/event/inspections/`,
};

export const rubricUrl = {
  BASE_URL: `${baseUrl}/rubric`,
};

export const baseUrls = {
  baseUrl:`${baseUrl}`
};

export const reportUrls = {
  GRADES_BY_CATEGORIES: `${baseUrl}/reports/gradesByEventCategorySummary`,
  GRADES_BY_USERS_AND_CAMP: `${baseUrl}/reports/gradesByUsersAndCamp`,
  GRADES_BY_EVENTS: `${baseUrl}/reports/gradesByEvents`,
  RANKING: `${baseUrl}/reports/ranking`,
  EVENTS: `${baseUrl}/grade/events`,
};